// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__28ZYB","additionalInfo":"AgreementModal_additionalInfo__2Csy3"};